module.exports = __webpack_public_path__ + "static/logo2v-05e363c2b23d6253e97405bce4027b9c.png";